export default function () {
  this.bindData = () => {
    this.application = JSON.parse($('#js-external-application-json').val())
    this.$el = $('#js-external-application-form')
  }

  this.initUI = () => new Kadenze.KdForms().update()

  this.save = () => {
    const url = this.application.id ?
      Kadenze.Routes.admin_external_application_path(this.application.id) :
      Kadenze.Routes.admin_external_applications_path()

    const request = new Kadenze.AjaxRequest({
      type: this.application.id ? 'PUT' : 'POST',
      url: url,
      data: { external_application: this.application },
      loadingIndicator: { container: this.$el },
      dataAsJSON: false,
    })

    request.done(data => Kadenze.Request.pjax({ url: data.redirect }))

    request.fail(data => Kadenze.UIUtil.showNotice(this.$el, data, 3000))
  }

  (() => this.bindData())()
}
